import { useEffect } from 'react';

// See https://react.dev/learn/you-might-not-need-an-effect.
// useMountEffect is useEffect(..., []) wrapped in a named hook to make intent explicit
// and prevent ad-hoc effect usage in components.
export function useMountEffect(effect: () => void | (() => void)) {
  // eslint-disable-next-line react-hooks/exhaustive-deps, modernloop/no-use-effect.cjs -- useMountEffect intentionally exposes the named mount-only effect primitive.
  useEffect(effect, []);
}
